import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "place/spot-folder"

class service {

    selectListGroupedByEnterpriseId(enterpriseId){

        let params = new URLSearchParams()
        params.append("enterpriseId", enterpriseId)
        params.append("status", "1")
        params.append("grouped", "true")

        return this.selectList(params)

    }


    selectList(params) {
        return http.list(path + "/selectList",params);
    }


}

export default new service();

